import {useColoreditStore} from "@km/components/color/colorEditStatusStore";
import {ColorAnimationVerwalter} from "@km/components/color/ColorAnimationVerwalter";
import {COLORMODULE_POSSIBLE_STATES} from "@km/components/color/ModuleColorAnimationStates";

function closeColorAnimationLayers() {
    ColorAnimationVerwalter.setModuleColorState(
        COLORMODULE_POSSIBLE_STATES.areaColorGroupSelection
    );
}

function resetColorEditStatus() {
    const statusStore = useColoreditStore();
    statusStore.reset();
}

export function closeAllLayersDownToAreaColorGroupings() {
    try {
        closeColorAnimationLayers();
    } catch (error) {
        console.warn("Could not close color animation layers.", error);
    }

    try {
        resetColorEditStatus();
    } catch (error) {
        console.warn("Could not reset color edit status.", error);
    }
}